import { AdminAnketaHeader } from './AdminAnketaHeader';

export default AdminAnketaHeader;